import { BillPayFlow } from '../bill-pay-flow/components/bill-pay-flows-wrapper';

const validBillPayFlows: readonly BillPayFlow[] = [
  'KNOWN_BENEFICIARY',
  'UNKNOWN_BENEFICIARY',
  'KNOWN_DESTINATION_BENEFICIARY_DOES_NOT_EXIST',
];

export const isBillPayFlow = (value: string | null): value is BillPayFlow => {
  if (value === null) {
    return false;
  }

  return validBillPayFlows.includes(value as BillPayFlow);
};
